<template>
  <div class="education_ist">
    <div class="educationList">
      <div class="educationList_box">
        <ul class="moduleList">
          <li class="educationList_item">
            <span class="educationList_title">招生信息</span>
            <div class="educationList_content">
              <img src="./image/1.png" alt="" @click="goMoreModule1"/>
              <ul class="newList">
                <!-- <li>
                  <span class="publishedTitle">关于2022年下半年四川大学高等教育</span> <span class="publishedTime">2022-06-02</span>
                </li>
                <li>
                  <span class="publishedTitle">关于2022年下半年四川大学高等教育</span> <span class="publishedTime">2022-06-02</span>
                </li>
                <li>
                  <span class="publishedTitle">关于2022年下半年四川大学高等教育</span> <span class="publishedTime">2022-06-02</span>
                </li> -->
                <li v-for="(item,index) in module1Arr" :key="index" @click="goModuleDetails(item)">
                  <span v-if="item.stick==1"><span class="publishedTitle"><span style="color:#BA2A17;">【置顶】</span><span>{{item.title}}</span> <span class="publishedTime">{{item.public_date}}</span></span></span>
                  <span v-else><span class="publishedTitle">{{item.title}}</span> <span class="publishedTime">{{item.public_date}}</span></span>
                </li>
              </ul>
              <span class="more" @click="goMoreModule1">更多>></span>
            </div>
          </li>
          <li class="educationList_item">
            <span class="educationList_title">教学运行</span>
            <div class="educationList_content">
              <img src="./image/2.png" alt="" @click="goMoreModule2"/>
              <ul class="newList">
                <li v-for="(item,index) in module2Arr" :key="index" @click="goModuleDetails(item)">
                  <span v-if="item.stick==1"><span class="publishedTitle"><span style="color:#BA2A17;">【置顶】</span><span>{{item.title}}</span> <span class="publishedTime">{{item.public_date}}</span></span></span>
                  <span v-else><span class="publishedTitle">{{item.title}}</span> <span class="publishedTime">{{item.public_date}}</span></span>
                </li>
              </ul>
              <span class="more" @click="goMoreModule2">更多>></span>
            </div>
          </li>
          <li class="educationList_item">
            <span class="educationList_title">考试考务</span>
            <div class="educationList_content">
              <img src="./image/3.png" alt="" @click="goMoreModule3"/>
              <ul class="newList">
                <li v-for="(item,index) in module3Arr" :key="index" @click="goModuleDetails(item)">
                  <span v-if="item.stick==1"><span class="publishedTitle"><span style="color:#BA2A17;">【置顶】</span><span>{{item.title}}</span> <span class="publishedTime">{{item.public_date}}</span></span></span>
                  <span v-else><span class="publishedTitle">{{item.title}}</span> <span class="publishedTime">{{item.public_date}}</span></span>
                </li>
              </ul>
              <span class="more" @click="goMoreModule3">更多>></span>
            </div>
          </li>
          <li class="educationList_item">
            <span class="educationList_title">学籍管理</span>
            <div class="educationList_content">
              <img src="./image/4.png" alt="" @click="goMoreModule4"/>
              <ul class="newList">
                <li v-for="(item,index) in module4Arr" :key="index" @click="goModuleDetails(item)">
                 <span v-if="item.stick==1"><span class="publishedTitle"><span style="color:#BA2A17;">【置顶】</span><span>{{item.title}}</span> <span class="publishedTime">{{item.public_date}}</span></span></span>
                  <span v-else><span class="publishedTitle">{{item.title}}</span> <span class="publishedTime">{{item.public_date}}</span></span>
                </li>
              </ul>
              <span class="more" @click="goMoreModule4">更多>></span>
            </div>
          </li>
          <li class="educationList_item">
            <span class="educationList_title">政策文件</span>
            <div class="educationList_content">
              <img src="./image/5.png" alt="" @click="goMoreModule5"/>
              <ul class="newList">
                <li v-for="(item,index) in module5Arr" :key="index" @click="goModuleDetails(item)">
                  <span v-if="item.stick==1"><span class="publishedTitle"><span style="color:#BA2A17;">【置顶】</span><span>{{item.title}}</span> <span class="publishedTime">{{item.public_date}}</span></span></span>
                  <span v-else><span class="publishedTitle">{{item.title}}</span> <span class="publishedTime">{{item.public_date}}</span></span>
                </li>
              </ul>
              <span class="more" @click="goMoreModule5">更多>></span>
            </div>
          </li>
          <li class="educationList_item">
            <span class="educationList_title">学位</span>
            <div class="educationList_content">
              <img src="./image/6.png" alt="" @click="goMoreModule6"/>
              <ul class="newList">
                <li v-for="(item,index) in module6Arr" :key="index" @click="goModuleDetails(item)">
                  <span v-if="item.stick==1"><span class="publishedTitle"><span style="color:#BA2A17;">【置顶】</span><span>{{item.title}}</span> <span class="publishedTime">{{item.public_date}}</span></span></span>
                  <span v-else><span class="publishedTitle">{{item.title}}</span> <span class="publishedTime">{{item.public_date}}</span></span>
                </li>
              </ul>
              <span class="more" @click="goMoreModule6">更多>></span>
            </div>
          </li>
        </ul>
      </div>
      <div class="whiteBg"></div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import serverUrl from "@/config/BaseConfigs";
import { getNewsList } from "@/api/api2";
import { Alert } from "element-ui";
export default {
  data() {
    return {
      //招生信息
      module1Arr:[],
      //教学运行
      module2Arr:[],
      //考试考务
      module3Arr:[],
      //学籍管理
      module4Arr:[],
      //政策文件
      module5Arr:[],
      //学位
      module6Arr:[],
      module1:{
        type: 225,
        pageSize: 3,
        pageNum: 1,
        searchWord: "",
      },
      module2:{
        type: 121,
        pageSize: 3,
        pageNum: 1,
        searchWord: "",
      },
      module3:{
        type: 274,
        pageSize: 3,
        pageNum: 1,
        searchWord: "",
      },
      module4:{
        type: 122,
        pageSize: 3,
        pageNum: 1,
        searchWord: "",
      },
      module5:{
        type: 529,
        pageSize: 3,
        pageNum: 1,
        searchWord: "",
      },
      module6:{
        type: 123,
        pageSize: 3,
        pageNum: 1,
        searchWord: "",
      },
    };
  },
  created() {
    //招生信息
    getNewsList(this.module1).then((res)=>{
      this.module1Arr=res.result;
    })
    //教学运行
    getNewsList(this.module2).then((res)=>{
      this.module2Arr=res.result;
    })
    //考试考务
    getNewsList(this.module3).then((res)=>{
      this.module3Arr=res.result;
    })
    //学籍管理
    getNewsList(this.module4).then((res)=>{
      this.module4Arr=res.result;
    })
    //政策文件
    getNewsList(this.module5).then((res)=>{
      this.module5Arr=res.result;
    })
    //学位
    getNewsList(this.module6).then((res)=>{
      this.module6Arr=res.result;
    })
  },
  methods: {
    goModuleDetails(item){
      window.open(serverUrl.moduleDetailUrl+"/home/news.do?id="+item.id);
    },
    goMoreModule1(){
      window.open("http://cce.scu.edu.cn/mana/view/home/newsList.do?type=225");
    },
    goMoreModule2(){
      window.open(serverUrl.moduleDetailUrl+"/home/newsList.do?type=121");
    },
    goMoreModule3(){
      window.open(serverUrl.moduleDetailUrl+"/home/newsList.do?type=274");
    },
    goMoreModule4(){
      window.open(serverUrl.moduleDetailUrl+"/home/newsList.do?type=122");
    },
    goMoreModule5(){
      window.open(serverUrl.moduleDetailUrl+"/home/newsList.do?type=529");
    },
    goMoreModule6(){
      window.open(serverUrl.moduleDetailUrl+"/home/newsList.do?type=123");
    }
  },
};
</script> 

<style scoped lang="scss">
.educationList {
  position: relative;
  width: 100%;
  height: 984px;
  background-color: #eeeef0;
  .whiteBg {
    position: absolute;
    top: 490px;
    width: 100%;
    height: 490px;
    background-color: #fff;
  }
  .educationList_box {
    position: relative;
    z-index: 99;
    width: 1200px;
    height: 490px;
    // background-color: pink;
    margin: 0 auto;
    .moduleList li {
      float: left;
    }
    .educationList_item {
      padding-right: 30px;
      margin-top: 58px;
      .educationList_title {
        font-size: 20px;
        font-weight: 600;
        color: #b92c14;
      }
      .educationList_content {
        overflow: hidden;
        img {
          cursor: pointer;
          transition: all 1s;
          &:hover {
            // opacity: .8;
            transform: scale(1.1);
          }
        }
        position: relative;
        width: 380px;
        height: 318px;
        margin-top: 26px;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 2px 2px 2px #88888814;
        .moduleList {
          width: 100%;
          box-sizing: border-box;
          padding: 10px;
          font-size: 14px;
          color: #333;
        }
        .newList {
          position: relative;
          font-size: 14px;
          padding: 10px;
          overflow: hidden;
          height: 80px;
          li {
            width: 100%;
            position: relative;
            line-height: 25px;
            cursor: pointer;
            .publishedTitle{
              // 强制一行显示
              white-space: nowrap;
              // 超出部分隐藏
              overflow: hidden;
              // 文字用省略号替代超出的部分
              text-overflow: ellipsis;
              display: inline-block;
              width: 250px;
            }
            .publishedTime {
              position: absolute;
              color: #999;
              right: 0;
            }
            &:hover{
              color: #B92C14;
            }
          }
        }
        .more {
          position: absolute;
          bottom: 12px;
          right: 10px;
          font-size: 14px;
          color: #999;
          cursor: pointer;
          &:hover {
            color: #ba2a17;
          }
        }
      }
    }
    .educationList_item:nth-child(3n) {
      padding-right: 0 !important;
    }
    .educationList_item:nth-child(n + 4) {
      margin-top: 120px;
    }
  }
}
</style>
